<template>
  <v-dialog v-model="internalValue" max-width="900px" persistent scrollable>
    <v-card class="rounded-xl border-light" outlined elevation="0">
      <!-- Header idéntico a la maqueta: Título a la izquierda, botones Cancelar y Guardar a la derecha -->
      <v-card-title class="py-3 px-5 d-flex align-center justify-space-between border-light-bottom bg-white">
        <div class="d-flex align-center">
          <v-btn icon small class="mr-2" @click="close">
            <v-icon color="grey darken-3">mdi-arrow-left</v-icon>
          </v-btn>
          <span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
            {{ isEditing ? 'Editar Capacitador' : 'Nuevo Capacitador' }}
          </span>
        </div>
        <div class="d-flex align-center">
          <v-btn text class="rounded-lg text-none font-weight-bold grey--text text--darken-3 px-4 mr-2" @click="close">
            Cancelar
          </v-btn>
          <v-btn color="primary" class="rounded-lg text-none font-weight-bold px-5 white--text" elevation="0" :loading="saving" @click="save">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-5 px-6">
        <v-row dense>
          <!-- Fila 1: Tipo de Capacitador & Capacitador (Interno / Externo) -->
          <v-col cols="12" sm="6">
            <s-select
              label="Tipo de Capacitador *"
              :items="trainerTypes"
              v-model="form.TrnType"
              @change="onTypeChange"
            />
          </v-col>

          <v-col cols="12" sm="6" v-if="form.TrnType === 1">
            <s-toolbar-person
              ref="tbPerson"
              v-model="form.TrnDocumentNumber"
              label="Buscar Colaborador Interno (DNI o Nombre) *"
              @returnPerson="onReturnInternalPerson"
              :noEdit="true"
              :noCamera="true"
            />
          </v-col>
          <v-col cols="12" sm="6" v-else>
            <s-text
              label="Capacitador Externo *"
              v-model="form.TrnExternalName"
              placeholder="Nombre completo del instructor"
            />
          </v-col>

          <!-- Fila 2: Nombre Completo (Interno) o Documento (Externo) & Organización -->
          <v-col cols="12" sm="6" v-if="form.TrnType === 1">
            <s-text
              label="Nombre Completo"
              v-model="form.TrnExternalName"
              readonly
              placeholder="Seleccione un colaborador interno"
            />
          </v-col>
          <v-col cols="12" sm="6" v-else>
            <s-text
              label="Documento"
              v-model="form.TrnDocumentNumber"
              placeholder="DNI / CE / Pasaporte"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <s-text
              label="Organización"
              v-model="form.TrnOrganization"
              placeholder="Empresa o institución"
            />
          </v-col>

          <!-- Fila 3: Especialidad & Correo -->
          <v-col cols="12" sm="6">
            <s-text
              label="Especialidad"
              v-model="form.TrnSpecialty"
              placeholder="Ej: Seguridad y Salud en el Trabajo, Inocuidad"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <s-text
              label="Correo"
              v-model="form.TrnEmail"
              type="email"
              placeholder="correo@ejemplo.com"
            />
          </v-col>

          <!-- Fila 4: Teléfono -->
          <v-col cols="12" sm="6">
            <s-text
              label="Teléfono"
              v-model="form.TrnPhone"
              placeholder="Teléfono / Celular de contacto"
            />
          </v-col>

          <!-- Fila 5: Carga de Curriculum Vitae (CV) -->
          <v-col cols="12">
            <v-card class="pa-3 border-light rounded-lg bg-light" outlined elevation="0">
              <div class="d-flex align-center justify-space-between flex-wrap">
                <div class="d-flex align-center">
                  <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                  <div>
                    <div class="font-weight-bold grey--text text--darken-3">Curriculum Vitae (CV) del Capacitador</div>
                    <div class="text-caption grey--text text--darken-1" v-if="form.TrnCvPath">
                      Archivo adjunto: <b>{{ form.TrnCvPath }}</b>
                    </div>
                    <div class="text-caption grey--text text--darken-1" v-else>
                      Sin archivo de CV adjunto (Formatos: PDF, Word)
                    </div>
                  </div>
                </div>
                <div class="d-flex align-center mt-2 mt-sm-0" v-if="form.TrnCvPath">
                  <v-btn small color="primary" outlined class="rounded-lg text-none font-weight-bold" @click="downloadCurrentCv">
                    <v-icon left small>mdi-download</v-icon>
                    Descargar CV
                  </v-btn>
                </div>
              </div>

              <v-file-input
                v-model="cvFile"
                label="Seleccionar archivo de CV (PDF / DOCX)"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                outlined
                dense
                hide-details
                accept=".pdf,.doc,.docx"
                class="rounded-lg mt-3"
                placeholder="Cargar nuevo archivo de CV..."
              ></v-file-input>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SText from "@/components/Utils/SText.vue";
import SSelect from "@/components/Utils/SSelect.vue";
import SToolbarPerson from "@/components/Utils/Person/sToolbarPerson.vue";
import TrainerService from "@/services/Management/TrainerService";
import _GenUploadFiles from "@/services/General/GenUploadFiles";

export default {
  name: "TrainerFormModal",
  components: {
    SText,
    SSelect,
    SToolbarPerson,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      cvFile: null,
      trainerTypes: [
        { text: "Interno (Colaborador Sunshine)", value: 1 },
        { text: "Externo (Consultora / Tercero)", value: 2 },
      ],
      form: {
        TrnID: 0,
        TrnType: 2, // Externo por defecto
        NtpID: null,
        TrnExternalName: "",
        TrnDocumentNumber: "",
        TrnOrganization: "",
        TrnSpecialty: "",
        TrnEmail: "",
        TrnPhone: "",
        TrnCvPath: null,
        SecStatus: 1,
      },
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isEditing() {
      return this.form.TrnID > 0;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.cvFile = null;
        if (this.editItem && this.editItem.TrnID) {
          this.form = Object.assign({}, this.editItem);
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.cvFile = null;
      this.form = {
        TrnID: 0,
        TrnType: 2,
        NtpID: null,
        TrnExternalName: "",
        TrnDocumentNumber: "",
        TrnOrganization: "",
        TrnSpecialty: "",
        TrnEmail: "",
        TrnPhone: "",
        TrnCvPath: null,
        SecStatus: 1,
      };
    },
    downloadCurrentCv() {
      if (this.form.TrnCvPath) {
        _GenUploadFiles.getFile("PathTrainingTrainerCV", this.form.TrnCvPath);
      }
    },
    onTypeChange(type) {
      if (type === 1) {
        this.form.TrnOrganization = "SUNSHINE EXPORT SAC";
      } else {
        this.form.NtpID = null;
        this.form.TrnOrganization = "";
      }
    },
    onReturnInternalPerson(person) {
      if (person) {
        this.form.NtpID = person.NtpID;
        this.form.TrnDocumentNumber = person.PrsDocumentNumber || person.NtpDocumentNumber || "";
        this.form.TrnExternalName = person.NtpFullName || person.PrsFullName || (person.NtpName + " " + person.NtpPaternalSurname);
        
        // Autocompletar correo electrónico si existe
        const email = person.UserEmail || (person.Emails && person.Emails.length > 0 ? (person.Emails[0].PrmEmail || person.Emails[0].PseEmail) : "") || person.NtpEmail || "";
        if (email) {
          this.form.TrnEmail = email;
        }

        // Autocompletar teléfono / celular si existe
        const phone = (person.Telephones && person.Telephones.length > 0 ? person.Telephones[0].PteNumber : "") || person.NtpPhone || "";
        if (phone) {
          this.form.TrnPhone = phone;
        }

        this.form.TrnSpecialty = person.PstName || person.AreName || "";
        this.form.TrnOrganization = "SUNSHINE EXPORT SAC";
      }
    },
    close() {
      this.internalValue = false;
    },
    async save() {
      if (this.form.TrnType === 2 && (!this.form.TrnExternalName || !this.form.TrnExternalName.trim())) {
        this.$fun.alert("Ingrese el nombre completo del capacitador externo.", "warning");
        return;
      }
      if (this.form.TrnType === 1 && !this.form.NtpID) {
        this.$fun.alert("Seleccione un colaborador interno mediante la búsqueda.", "warning");
        return;
      }

      const confirmed = await this.$fun.alert("¿Está seguro de guardar la información del capacitador?", "question");
      if (!confirmed || !confirmed.value) return;

      this.saving = true;
      try {
        // Subir archivo de CV si se seleccionó uno nuevo
        if (this.cvFile && typeof this.cvFile === "object" && this.cvFile instanceof File) {
          const cleanDoc = (this.form.TrnDocumentNumber || "TRN").replace(/[^a-zA-Z0-9]/g, "");
          const uniqueName = `CV_${cleanDoc}_${Date.now()}`;
          const res = await _GenUploadFiles.upload(this.cvFile, uniqueName, "PathTrainingTrainerCV", true);
          this.form.TrnCvPath = res?.data?.fileName || `${uniqueName}.${this.cvFile.name.split('.').pop()}`;
        }

        const reqId = this.$fun.getUserID();
        await TrainerService.save(this.form, reqId);
        this.$fun.alert("Capacitador guardado correctamente.", "success");
        this.$emit("saved");
        this.close();
      } catch (err) {
        this.$fun.alert(err?.response?.data?.Message || "Error al guardar capacitador.", "error");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
